import { useEffect, useState } from 'react'
import {
  ApiGetUserEnvironmentData, ApiGetUserEnvironmentDataDemandType, ApiGetUserEnvironmentDataResponse
} from 'src/api'
import { useAppSelector } from 'src/hooks'
import { useAbortController } from 'src/hooks/useAbortFetch'
import { selectUser } from 'src/redux'

interface Props {
  demandList?: ApiGetUserEnvironmentDataDemandType[]
  fetchOnLoad?: boolean
  environmentDataId: string
}

export const useUserEnvironmentData = ({ demandList, fetchOnLoad, environmentDataId }:Props) => {
  const { serverUrl, token } = useAppSelector(selectUser)
  const [loading, setLoading] = useState(false)
  const [environmentData, setEnvironmentData] = useState<ApiGetUserEnvironmentDataResponse>({
    channelAuxList: [],
    environmentDataAuxList: [],
    hotelAuxList: [],
    roomAuxList: [],
    roomTypeAuxList: [],
    roomTypeCapacityAuxList: [],
    zoneAuxList: []
  })
  const controller = new AbortController()

  const getData = async () => {
    try {
      setLoading(true)
      const response = await ApiGetUserEnvironmentData({
        serverPath: serverUrl,
        controller,
        data: {
          environmentDataId,
          userToken: token,
          dataDemandList: demandList ?? []
        }
      })
      setEnvironmentData(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (fetchOnLoad) getData()
  }, [])

  return {
    loading,
    environmentData,
    getData
  }
}
